import { MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, Output, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, Subscription } from 'rxjs';
import _cloneDeep from 'lodash/cloneDeep';
import { Utils } from 'formiojs';
import { SortHelper } from '../../helpers/sort.helper';
import { ClassificationIndicator, ClassificationStatus } from './models/classification-indicators.model';
import { ClassificationIndicatorComponent } from './indicator/classification-indicator.component';
import { reviver } from '../../helpers/json.helper';
import { FormioLoader, FormioCustomComponent, ResourceNameService } from 'dp-formio';


@Component({
  selector: 'app-classification-indicators-wrapper',
  templateUrl: './classification-indicators-wrapper.component.html',
  // styleUrls: ['./classification-indicators-wrapper.component.scss']
  encapsulation: ViewEncapsulation.None,
  providers: [FormioLoader]
})
export class ClassificationIndicatorsWrapperComponent implements FormioCustomComponent<any>, OnDestroy, OnChanges {
  dir: 'rtl' | 'ltr';
  @Input() required: boolean;

  @Input()
  value: any = {};

  @Output()
  valueChange = new EventEmitter<any>();

  @Input()
  disabled: boolean;

  @Input()
  viewOnly: boolean;

  @Input()
  data: any;

  @Input()
  customOptions: any;

  @Input()
  formioComponent: any;

  indicatorQuery = ``;
  indicators: ClassificationIndicator[] = [];
  indicatorStatus = ClassificationStatus;

  hideSummary: boolean;

  hideQuestions: boolean;
  hideAttachments: boolean;
  hideNotesAndRecommendations: boolean;
  hideDecision: boolean;
  hideSaveDomain: boolean;
  hideComments: boolean;

  disableQuestions: boolean;
  disableAttachments: boolean;
  disableNotesAndRecommendations: boolean;
  disableDecision: boolean;
  disableComments: boolean;

  private subs: Subscription[] = [];
  set sub(s: Subscription) { this.subs.push(s); }

  constructor(private translateService: TranslateService,
    private resourceNameService: ResourceNameService,
    private matDialog: MatDialog,
    private formioLoader: FormioLoader) {
    this.changeDirection(this.translateService.currentLang);
    this.sub = this.translateService.onLangChange.subscribe(data => {
      this.changeDirection(data.lang);
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.customOptions && this.customOptions.indicatorResource) {
      this.indicatorQuery = this.formioComponent.interpolate(this.customOptions.indicatorQuery, { data: this.data });

      this.hideSummary = eval(this.formioComponent.interpolate(this.customOptions.hideSummary, { data: this.data }));

      this.hideQuestions = eval(this.formioComponent.interpolate(this.customOptions.hideQuestions, { data: this.data }));
      this.hideAttachments = eval(this.formioComponent.interpolate(this.customOptions.hideAttachments, { data: this.data }));
      this.hideNotesAndRecommendations = eval(this.formioComponent.interpolate(this.customOptions.hideNotesAndRecommendations, { data: this.data }));
      this.hideDecision = eval(this.formioComponent.interpolate(this.customOptions.hideDecision, { data: this.data }));
      this.hideSaveDomain = eval(this.formioComponent.interpolate(this.customOptions.hideSaveDomain, { data: this.data }));
      this.hideComments = eval(this.formioComponent.interpolate(this.customOptions.hideComments, { data: this.data }));

      this.disableQuestions = eval(this.formioComponent.interpolate(this.customOptions.disableQuestions, { data: this.data }));
      this.disableAttachments = eval(this.formioComponent.interpolate(this.customOptions.disableAttachments, { data: this.data }));
      this.disableNotesAndRecommendations = eval(this.formioComponent.interpolate(this.customOptions.disableNotesAndRecommendations, { data: this.data }));
      this.disableDecision = eval(this.formioComponent.interpolate(this.customOptions.disableDecision, { data: this.data }));
      this.disableComments = eval(this.formioComponent.interpolate(this.customOptions.disableComments, { data: this.data }));

      this.getIndicatorsResources();
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
    this.subs = [];
  }

  openIndicator(indicator: ClassificationIndicator, isSummary = false) {
    const dialog = this.matDialog.open(ClassificationIndicatorComponent, {
      id: Utils.guid(),
      data: {
        dir: this.dir,
        submission: this.data,
        indicator: _cloneDeep(indicator),
        customOptions: this.customOptions,
        viewOnly: this.viewOnly,
        isSummary: isSummary,
        formData: this.formioComponent?.root?.data,
        formioComponent: this.formioComponent,
        options: {
          hideQuestions: this.hideQuestions,
          hideAttachments: this.hideAttachments,
          hideNotesAndRecommendations: this.hideNotesAndRecommendations,
          hideDecision: this.hideDecision,
          hideSaveDomain: this.hideSaveDomain,
          hideComments: this.hideComments,
          disableQuestions: this.disableQuestions,
          disableAttachments: this.disableAttachments,
          disableNotesAndRecommendations: this.disableNotesAndRecommendations,
          disableDecision: this.disableDecision,
          disableComments: this.disableComments
        }
      },
      height: '100vh',
      width: '100vw',
      panelClass: 'full-screen-modal',
      disableClose: true
    });
    const sub = dialog.afterClosed().subscribe(result => {
      sub.unsubscribe();
      if (result) {
        this.indicators[this.indicators.findIndex(q => q._id == result._id)] = result;
        this.notifyValue();
      }
      this.formioComponent?.root?.events?.emit('formio.registerComponent');
    });
  }

  private notifyValue() {
    if (this.required) {
      if (this.indicators.some(q => !q.isValid)) {
        this.value = null;
        this.valueChange.emit(this.value);
        this.afterChangeValue();
        return;
      }
    }
    this.value = { indicatorsData: this.indicators.map(q => q._id) };
    this.valueChange.emit(this.value);
    this.afterChangeValue();
  }

  private afterChangeValue() {
    if (this.customOptions && this.customOptions.afterChange)
      this.customOptions.afterChange.forEach(item => {
        const mustUpdateValues = eval(this.formioComponent.interpolate(item.condition, { data: this.data }));
        if (mustUpdateValues) {
          if (this.formioComponent.root.wizard) {
            const pages = this.formioComponent.root.getFastPages({ all: true, withoutFirstLoad: true });
            this.searchAndUpdateComponent(pages, item);
          } else {
            const nestedForms = Utils.searchComponents(this.formioComponent.root.components, { type: 'form', 'component.display': 'wizard' });
            nestedForms.forEach(formComponent => {
              formComponent.subFormReady.then((subForm) => {
                const pages = subForm.getFastPages({ all: true, withoutFirstLoad: true });
                this.searchAndUpdateComponent(pages, item);
              });
            });

            const components = this.searchAndUpdateComponent(this.formioComponent.root.components, item);
            if (!components?.length) {
              const nestedForms = Utils.searchComponents(this.formioComponent.root.components, { type: 'form' });
              nestedForms.forEach(formComponent => {
                formComponent.subFormReady.then((subForm) => {
                  this.searchAndUpdateComponent(subForm.components, item);
                });
              });
            }
          }
        }
      });
  }

  private searchAndUpdateComponent(formComponents: any[], afterChangeItem: any): any[] {
    const components = Utils.searchComponents(formComponents, { key: afterChangeItem.key });
    components.forEach(c => {
      const value = this.formioComponent.interpolate(afterChangeItem.value, { data: this.data, indicators: this.indicators, indicatorStatus: this.indicatorStatus });
      c.setValue(value);
    });
    return components;
  }

  private changeDirection(lang) {
    this.dir = null;
    setTimeout(() => { this.dir = lang === 'ar' ? 'rtl' : 'ltr'; });
  }

  private getIndicatorsResources() {
    if (!this.formioComponent.visible) return;
    this.formioLoader.loading = true;

    this.sub = this.resourceNameService.loadCustomByFilterdKey(this.customOptions.indicatorResource, this.indicatorQuery).pipe(
      map((resultData: any[]) => {
        return SortHelper.recursiveSort(resultData.map(q => { return { _id: q._id, ...q.data } }), 'asc').map(q => {
          const item = new ClassificationIndicator();
          SortHelper.copyProps(q, item);
          item.attachmentsFormKey = this.customOptions.attachmentsForm;
          item.domainNotesAndRecommendationsFormKey = this.customOptions.domainNotesAndRecommendationsForm;
          if (q.history) item.history = JSON.parse(q.history, reviver);
          return item;
        })
      }))
      .subscribe(data => {
        if (data && data.length) {
          this.indicators = data;
          this.notifyValue();
        }
        this.formioLoader.loading = false;
      }, error => {
        this.formioLoader.loading = false;
      });
  }
}
